"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

var SvgCrop = function SvgCrop(props) {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M18.139 12a1 1 0 01.991 1.009l-.036 4.068L28 17a3 3 0 013 3v8.999L35 29a1 1 0 010 2l-4-.001V35a1 1 0 11-2 0v-4.001L20 31c-1.657 0-3-1.343-3-3.009l.077-8.897-4.068.036a1 1 0 01-.018-2l4.103-.036.036-4.103A1 1 0 0118.139 12zm9.87 7l-8.932.076L19 28a1 1 0 001 1l9-.001V20c0-.552-.448-1-.991-1z",
    id: "crop_svg__a"
  }));
};

var _default = SvgCrop;
exports["default"] = _default;